<template>
  <rank-division-picker
    :type="'currentRank'"
    item-key="winBoosting"
    :title="$t('calculators_common.current_rank')"
    class="full-width"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_wins')"
    :description="$t('calculators_common.select_number_of_wins')"
    type="wins"
    :max="10"
  />
  <QueuePicker />
  <PlatformPicker />
  <OptionPicker />
</template>

<script setup>
import OptionPicker from "./pickers/OptionPicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import RankDivisionPicker from "./pickers/RankDivisionPick.vue";
import QueuePicker from "./pickers/QueuePicker.vue";
import RangePicker from "../commonpickers/RangePicker.vue";
import { onMounted } from "vue";
const {
  setDetails,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setQueue,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack } = useGameStore();

const handleDetails = () => {
  clearCheckout();

  setDetails({
    currentDivision: 86,
    currentDivisionTitle: "III",
    currentRank: 28,
    currentRankTitle: "Bronze",
    numberOfWins: 1,
  });

  setQueue(70);
  setPlatform({
    platform: 1,
  });
  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});
</script>
